<!-- @format -->

<template>
	<el-form-item :class="['pc-form-item', !label ? 'pc-form-item-hidden-label' : '']">
		<template #label>
			<el-tooltip v-if="label" effect="dark" :content="label" placement="top-start" :show-after="500">
				<span class="el-form-item__label_val">
					{{ label }}
				</span>
			</el-tooltip>
			<pc-help-tip v-if="helpTips" type="tooltip" :content="helpTips" placement="top-start" />
		</template>
		<slot></slot>
	</el-form-item>
</template>

<script setup lang="ts">
	import { PcHelpTip } from '@/components';

	interface Props {
		label?: string;
		helpTips?: string;
		labelPosition?: 'left' | 'top' | 'right';
		valuePosition?: 'left' | 'center' | 'right';
	}

	const props = withDefaults(defineProps<Props>(), {});

	const labelPositionVal = computed(() => (props.labelPosition === 'right' ? 'flex-end' : 'flex-start'));

	const valuePositionVal = computed(() =>
		props.valuePosition === 'right' ? 'flex-end' : props.valuePosition === 'center' ? 'center' : 'flex-start',
	);
</script>

<style scoped lang="scss">
	.pc-form-item {
		:deep(.el-form-item__label) {
			display: flex;
			align-items: center;
			gap: 3px;
			justify-content: v-bind(labelPositionVal);
		}

		:deep(.el-form-item__content) {
			justify-content: v-bind(valuePositionVal);
		}

		:deep(.el-input) {
			width: 100% !important;
		}

		:deep(.el-cascader) {
			width: 100% !important;
		}
	}

	.pc-form-item-hidden-label > :deep(.el-form-item__label-wrap) {
		display: none;
	}

	.pc-form-item-hidden-label > :deep(.el-form-item__label) {
		display: none;
	}
</style>
